import { ApiError } from './base/ApiError';

/**
 * 5xx系エラー
 */
export class ApiServerError extends ApiError {
  override name = 'ApiServerError';
}
